import { useEffect, useState } from 'react';

export interface AuthUser {
  sub: string;
  role: string;
  upn: string;
  name: string;
  exp: number;
}

export function useAuth(): {
  user: AuthUser | null;
  loading: boolean;
  loginUrl: string;
  logoutUrl: string;
} {
  const [user, setUser] = useState<AuthUser | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const ac = new AbortController();
    fetch('/api/v1/auth/me', { credentials: 'same-origin', signal: ac.signal })
      .then(async (r) => {
        if (ac.signal.aborted) return;
        if (r.ok) {
          const data = (await r.json()) as { user: AuthUser };
          if (!ac.signal.aborted) setUser(data.user);
        }
      })
      .catch(() => {
        /* ignorar (incluye AbortError) */
      })
      .finally(() => {
        if (!ac.signal.aborted) setLoading(false);
      });
    return () => ac.abort();
  }, []);

  return {
    user,
    loading,
    loginUrl: '/auth/login',
    logoutUrl: '/auth/logout',
  };
}
